import React from "react";

import AttendeeTable from "components/Cards/AttendeeTable";

export default function Attendee() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <AttendeeTable />
        </div>
      </div>
    </>
  );
}
